export enum EnumAssignTo {
  POS = 'POS',
  COURIER = 'Kurir',
}

/**
 * Wire values of `seller_role` / `role`.
 * UI labels are resolved by value (never the other way around) so that
 * relabeling (e.g. CLIENT -> "Aggregator") does not break hydration.
 */
export enum EnumSellerRole {
  TOKOPEDIA = 'TOKOPEDIA',
  BUKALAPAK = 'BUKALAPAK',
  MERCHANT = 'MERCHANT',
  CLIENT = 'CLIENT',
  COMPANY = 'COMPANY',
}

export const SELLER_ROLE_LABEL: Record<EnumSellerRole, string> = {
  [EnumSellerRole.TOKOPEDIA]: 'Tokopedia',
  [EnumSellerRole.BUKALAPAK]: 'Bukalapak',
  [EnumSellerRole.MERCHANT]: 'Merchant',
  [EnumSellerRole.CLIENT]: 'Aggregator',
  [EnumSellerRole.COMPANY]: 'Corporate',
}

export interface SellerRoleOption {
  label: string
  value: EnumSellerRole
}

const toSellerRoleOption = (role: EnumSellerRole): SellerRoleOption => ({
  label: SELLER_ROLE_LABEL[role],
  value: role,
})

/** Roles that can be created. Merchant is legacy-only (List/Detail/Edit). */
export const CREATE_SELLER_ROLE_OPTIONS: SellerRoleOption[] = [
  EnumSellerRole.TOKOPEDIA,
  EnumSellerRole.BUKALAPAK,
  EnumSellerRole.CLIENT,
  EnumSellerRole.COMPANY,
].map(toSellerRoleOption)

/** Every role that may exist on a stored whitelist row. */
export const ALL_SELLER_ROLE_OPTIONS: SellerRoleOption[] = [
  EnumSellerRole.TOKOPEDIA,
  EnumSellerRole.BUKALAPAK,
  EnumSellerRole.MERCHANT,
  EnumSellerRole.CLIENT,
  EnumSellerRole.COMPANY,
].map(toSellerRoleOption)

export const COD_HANDLING_OPTIONS = [
  { label: 'specialcod', value: 'specialcod' },
  { label: 'standardcod', value: 'standardcod' },
]
